import React from 'react';
import {
  makeStyles,
  Box,
  Button,
  Drawer,
  Divider,
  Typography,
  CardNotification,
} from '@dxb-web-ui-framework/design-system';
import { Mail as MailIcon, Close as CloseIcon, Info as InfoIcon } from '@dxb-web-ui-framework/design-system/dist/icons';
import { useScreenDetector } from '@dxb-web-ui-framework/common/hooks';

type MainMenuProps = {
  isNotificationMenuOpen: boolean;
  onClose: () => void;
  notifications: any[];
};

const useStyles = makeStyles(theme => ({
  menu: {
    height: '100%',
    overflow: 'hidden',
    width: theme.spacing(40),
    [theme.breakpoints.down('sm')]: {
      width: '100vw',
    },
  },
  menuBody: {
    overflowY: 'scroll',
  },
}));

const NotificationMenu: React.FC<MainMenuProps> = ({ isNotificationMenuOpen, onClose, notifications }) => {
  const classes = useStyles();
  const { isExtraSmallScreen: isMobile } = useScreenDetector();

  return (
    <Drawer anchor={isMobile ? 'bottom' : 'right'} open={isNotificationMenuOpen} variant='temporary' onClose={onClose}>
      <Box display='flex' flexDirection='column' className={classes.menu}>
        {/* Menu Header(non-scrollable) items */}
        <Box>
          <Box p={3} pt={5} display='flex' justifyContent='space-between' alignItems={'center'}>
            <Typography variant='h6'>Notifications</Typography>
            <Button
              aria-label='Close Notifications Menu'
              color='secondary'
              isIconButton
              size='small'
              title='Close Notifications Menu'
              variant='text'
              onClick={onClose}>
              <CloseIcon />
            </Button>
          </Box>
          <Divider />
        </Box>

        {/* Menu Body(scrollable) items */}
        <Box
          className={classes.menuBody}
          display={'flex'}
          flexDirection={'column'}
          flexWrap={'nowrap'}
          alignContent={'center'}
          alignItems={'center'}>
          {/* TODO: Change this feature whith notification fields */}
          {notifications.map(notification => (
            <Box m={2} key={notification.id}>
              <CardNotification
                date={notification.date}
                icon={notification.severity === 'warning' ? <InfoIcon /> : <MailIcon />}
                severity={notification.severity}
                subtitle={notification.subtitle}
                title={notification.title}
                onClick={() => {}}
              />
            </Box>
          ))}
        </Box>
      </Box>
    </Drawer>
  );
};

export { NotificationMenu };
